__webpack_require__.p = "https://widget.gogander.online/";